var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hk-video",attrs:{"id":"hkVideo"}},[_c('div',{staticClass:"playWnd",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":`playWnd${_vm.HKIdx}`}}),_c('p',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }